// extracted by mini-css-extract-plugin
module.exports = {"form":"ViewRegister_form__3-YWJ"};